import { z } from "zod";

export const companySchema = z.object({
  id: z.number(),
  company_name: z.string().nullish(),
  company_name_kana: z.string().nullish(),
  registration_number: z.string().nullish(),
  is_listed: z.coerce.boolean(),
  funds: z.coerce.number().nullish(),
  ceo_name: z.string().nullish(),
  ceo_name_kana: z.string().nullish(),
  email: z.union([z.string().email(), z.literal(""), z.null()]),
  position: z.string().nullish(),
  established_date: z.string().nullish(),
  homepage_url: z.string().url().nullish(),
  company_address: z.string().nullish(),
  employee_count: z.coerce.number(),
  phone_number: z.string().nullish(),
  corporate_number: z.string().nullish(),
  market_name: z.string().nullish(),
  foreign_employee_count: z.coerce.number().nullish(),
  permanent_employee_count: z.coerce.number().nullish(),
  contract_employee_count: z.coerce.number().nullish(),
  temporary_employee_count: z.coerce.number().nullish(),
  contractor_count: z.coerce.number().nullish(),
  part_time_employee_count: z.coerce.number().nullish(),
  intern_count: z.coerce.number().nullish(),
  specialist_count: z.coerce.number().nullish(),
  employee_countries: z.string().nullish(),
  start_date: z.string().nullish(),
  end_date: z.string().nullish(),
});

export type Company = z.infer<typeof companySchema>;
